
import {
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";
import { SubscriptionTierCard } from "./SubscriptionTierCard";
import { useIsMobile } from "@/hooks/use-mobile";

interface SubscriptionTier {
  name: string;
  price: number;
  priceId: string;
  queueLimit: number;
  description: string;
  features: string[];
}

interface SubscriptionPlansContentProps {
  tiers: SubscriptionTier[];
  isLoading: boolean;
  selectedTier: string | null;
  onSubscribe: (priceId: string) => Promise<void>;
}

export function SubscriptionPlansContent({
  tiers,
  isLoading,
  selectedTier,
  onSubscribe,
}: SubscriptionPlansContentProps) {
  const isMobile = useIsMobile();

  return (
    <DialogContent className="sm:max-w-[800px]">
      <DialogHeader>
        <DialogTitle>Choose Your Plan</DialogTitle>
        <DialogDescription>
          Select the plan that best fits your business needs
        </DialogDescription>
      </DialogHeader>
      <ScrollArea className={isMobile ? "h-[60vh]" : "h-full"}>
        <div className="grid md:grid-cols-2 gap-6 py-4 px-1">
          {tiers.map((tier) => (
            <SubscriptionTierCard
              key={tier.name}
              name={tier.name}
              price={tier.price}
              description={tier.description}
              features={tier.features}
              priceId={tier.priceId}
              isLoading={isLoading}
              selectedTier={selectedTier}
              onSubscribe={onSubscribe}
            />
          ))}
        </div>
      </ScrollArea>
    </DialogContent>
  );
}
